<template>
  <el-row class="split-layout">
    <el-col :span="5" class="split-layout-left">
      <folder-tree-panel
        title="活动图文件夹"
        :tree-data="treeData"
        :current-id="currentFolderId"
        search-type="2"
        @node-click="handleNodeClick"
        @delete-node="handleDeleteNode"
      />
    </el-col>
    <el-col :span="19" class="split-layout-right">
      <store-activity-content
        :folder-id="currentFolderId"
        :folder-name="currentFolderName"
        @open-template-config="openTemplateConfigPage"
      />
    </el-col>
  </el-row>
</template>

<script>
import pagePathMixin from '@/utils/page-path-mixin'
import mockService from '../../mockService'
import FolderTreePanel from '../panels/FolderTreePanel.vue'
import StoreActivityContent from '../panels/StoreActivityContent.vue'

function findNodeName (tree = [], targetId) {
  for (let i = 0; i < tree.length; i += 1) {
    const item = tree[i]
    if (item.id === targetId) return item.label
    if (item.children && item.children.length) {
      const name = findNodeName(item.children, targetId)
      if (name) return name
    }
  }
  return ''
}

export default {
  name: 'StoreActivityTab',
  components: {
    FolderTreePanel,
    StoreActivityContent
  },
  mixins: [pagePathMixin],
  data () {
    return {
      treeData: [],
      currentFolderId: '',
      currentFolderName: ''
    }
  },
  mounted () {
    this.fetchTree()
  },
  methods: {
    fetchTree () {
      mockService.getActivityFolders().then(res => {
        this.treeData = res.data.tree || []
        this.currentFolderId = res.data.defaultFolderId || ''
        this.currentFolderName = findNodeName(this.treeData, this.currentFolderId)
      })
    },
    refreshTree () {
      const currentFolderId = this.currentFolderId
      mockService.getActivityFolders().then(res => {
        this.treeData = res.data.tree || []
        const nextFolderId = findNodeName(this.treeData, currentFolderId)
          ? currentFolderId
          : (res.data.defaultFolderId || '')
        this.currentFolderId = nextFolderId
        this.currentFolderName = findNodeName(this.treeData, this.currentFolderId)
      })
    },
    handleNodeClick (node) {
      this.currentFolderId = node.id
      this.currentFolderName = node.label
    },
    handleDeleteNode (node) {
      this.$confirm(`确认删除文件夹“${node.label}”吗？`, '提示', { type: 'warning' }).then(() => {
        return mockService.deleteStoreDecorationFolder({ folderId: node.id })
      }).then((res) => {
        this.$message.success('删除成功')
        this.refreshTree()
      }).catch((error) => {
        if (error && error.message) {
          this.$message.error(error.message)
        }
      })
    },
    openTemplateConfigPage () {
      this.openSubPage({
        path: '/newProduct/storeDecorationTemplateConfig'
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.split-layout
  height calc(100vh - 130px)

.split-layout-left,
.split-layout-right
  height 100%
</style>
